import React from 'react';
import { ReactComponent as Twitter } from "assets/svg/twitter_mobile.svg";
import { ReactComponent as Telegram } from "assets/svg/telegram_mobile.svg";
import { ReactComponent as SnapChat } from "assets/svg/snapchat_mobile.svg";
import { ReactComponent as WhatsApp } from "assets/svg/whatsapp_mobile.svg";
import { ReactComponent as Share } from "assets/svg/share_mobile.svg";
import { getI18n, useTranslation } from "react-i18next";
import './_mobileSocialMedia.scss'

const MobileSocialMedia = () => {
     const { i18n, t } = useTranslation();  
     const trackEvent = (tabClicked) => {
		window.lmSMTObj.track(tabClicked);
	}
     return (
        <div className="socila-media-wrapper-mobile-outer">
            <h4 className="social-heading">
                {/* Share with your friends! */}
                {t("Petromin.bottomHeader")}
                </h4>
            <ul className="socila-media-wrapper-mobile">
                <li className="social-item-wrap">
                    <a onClick={() => {trackEvent("TwitterClicked")}} title="https://mobile.twitter.com/tawuniya" className="social-item" target={"_blank"} href="https://mobile.twitter.com/tawuniya">
                        <Twitter className="icon-social" />
                    </a>
                </li>
                {/* <li className="social-item-wrap">
                    <a  title="" className="social-item" href="#">
                        <Telegram className="icon-social" />
                    </a>
                </li> */}
                {/* <li className="social-item-wrap">
                    <a  title="" className="social-item" href="#">
                        <SnapChat className="icon-social" />
                    </a>
                </li> */}
                <li className="social-item-wrap">
                    <a onClick={() =>{trackEvent("WhatsAppClicked")}}  title="https://wa.me/+966920019990" className="social-item" target={"_blank"} href="https://wa.me/+966920019990">
                        <WhatsApp className="icon-social" />
                    </a>
                </li>
                {/* <li className="social-item-wrap">
                    <a  title="" className="social-item" href="#">
                        <Share className="icon-social" />
                    </a>
                </li> */}
            </ul>
        </div>
    )
}

export default MobileSocialMedia;